// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"5257": "88225f65dff9","5725": "1cebcc8c1879","6863": "454c9f289029","7658": "3505e50fd8f4",}[chunkId] + ".css"
}